import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
export function CTABanner() {
  return <section className="py-20 bg-forest relative overflow-hidden" data-id="element-6">
      {/* Decorative elements */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-gold rounded-full mix-blend-multiply filter blur-3xl opacity-20 transform translate-x-1/2 -translate-y-1/2" data-id="element-7"></div>
      <div className="absolute bottom-0 left-0 w-80 h-80 bg-cream rounded-full mix-blend-overlay filter blur-3xl opacity-10 transform -translate-x-1/2 translate-y-1/2" data-id="element-8"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10" data-id="element-9">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-10">
          <h2 className="text-3xl md:text-5xl font-bold text-cream mb-6" data-id="element-11">
            Ready to Design Your Dream Home?
          </h2>
          <p className="text-lg text-cream/80 mb-10 max-w-2xl mx-auto" data-id="element-12">
            Skip the imagination phase. Step inside, customize your finishes,
            and see exactly what your future home will look like today.
          </p>
          <Button to="/experience" size="lg" className="text-lg px-10 py-4 shadow-xl" data-id="element-13">
            Start Designing Now
          </Button>
        </motion.div>
      </div>
    </section>;
}